import { splitSelectedCourse } from "@/src/utils/admissionOffice/splitSelectedCourse";

/** Splits legacy combined course strings for table/popup display. */
export const resolveDisplayDegreeAndCourse = (
  rawCourse?: string | null,
  rawLevelEducation?: string | null,
): { degree: string; course: string } => {
  const explicitDegree = String(rawLevelEducation ?? "").trim();
  const raw = String(rawCourse ?? "").trim();

  if (!raw) {
    return { degree: explicitDegree, course: "" };
  }

  const split = splitSelectedCourse(raw);

  if (explicitDegree) {
    return {
      degree: explicitDegree,
      course: split.selectedCourse || raw,
    };
  }

  return {
    degree: split.degree,
    course: split.selectedCourse || raw,
  };
};
